import React from 'react';

function Apartment() {
    return <div>Apartment</div>;
}

export default Apartment;
